var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"filter-results"},[_c('filter-results-display',{staticClass:"filter-results__display",attrs:{"shown":_vm.shown,"total":_vm.total},on:{"clear":_vm.clearFilters}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }